export const suppressToast = (message: string | undefined): boolean => {
  if (message === undefined) return false;

  // Список сообщений, для которых не нужно показывать toast
  const suppressedMessages = [
    'Указанный заказ не найден',
    'Пришла ошибка - Указанный заказ не найден',
    'Произошла ошибка чтения ответа - Syntax error',
    // `404` пустой ленты комментариев — не ошибка: с PAR-5189 лента грузится
    // для каждой открытой карточки заказа (getOrderCommentsThunk).
    'По заказу нет комментариев'
  ];

  return suppressedMessages.includes(message);
};
